import React from 'react'

export default function SurveyForm() {
  return (
    <div>
        <iframe 
        src="https://docs.google.com/forms/d/e/1FAIpQLSfDsC7xszuy-M2gpX2I8PnHi9feZl_HxdfAIQ1TVCGG9zVfDA/viewform?embedded=true"
        className="lg:w-[640px] w-full h-[1367px] border-0 p-0 m-auto">
            Loading…
        </iframe>
    </div>
  )
}
